import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'
import { InWinImage } from 'routes/shared/components'

import * as styles from './styles'

const CardComponent = ({ logo, label, renderLabel, selected, className }) => {
  let content

  if (logo) {
    content = <InWinImage source={logo} alt={label} css={styles.image} />
  } else if (renderLabel) {
    content = renderLabel(label)
  } else {
    content = <Text size={16}>{label}</Text>
  }

  return (
    <figure
      data-label={label}
      css={[styles.card, selected && styles.selected]}
      className={className}
    >
      <div css={styles.imageWrapper}>{content}</div>
    </figure>
  )
}

CardComponent.propTypes = {
  selected: PropTypes.bool,
  logo: PropTypes.string,
  renderLabel: PropTypes.func,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default CardComponent
